/* eslint-disable */
export default {
  _asapbold: 'asapbold',
  _asapregular: 'asapregular',
}